import { UserModule } from '@/store/modules/user'
import { ApiService } from './api.service'

export async function hasOpeAccess(): Promise<boolean> {

    const allBuyerOpes = await getSessionUserOperations()
    return testAcces(allBuyerOpes)
}

export async function getSessionUserOperations() {
    const apiService = new ApiService()

    await UserModule.Init()
    const userID = UserModule.userInfos.id

    if (userID === null) {
        return []
    }

    const allBuyerOpesResp = await apiService.getUserOperations(userID)
    const allBuyerOpes = allBuyerOpesResp.data

    return allBuyerOpes
}

export function getOperation(): string {
    const url = window.location.hostname.split('.')
    if (url[0] !== 'yvivre' && url[0] !== 'app') {
        return url[0]
    } else {
        return ''
    }
}

export async function getOperationBuyerState() {
    const apiService = new ApiService()

    const opeID = await getOperationID()
    const opeResp = await apiService.getOperation(opeID)

    if (UserModule.token == undefined) {
        UserModule.Init()
    }

    const buyerResp = await apiService.getBuyer(UserModule.userInfos.id)

    let planValidated = false
    try {
        const userOpeResp = await apiService.getUserOperation(UserModule.userInfos.id, opeID)
        planValidated = !!(userOpeResp.data as any).planValidated
    } catch (e) { /* silent */ }

    return {
        phase: opeResp.data.phase,
        status: buyerResp.data.status,
        planValidated,
    }
}

function testAcces(opes): boolean {
    const slugOpe = getOperation()
    let errorAccess = true
    opes.forEach(item => {
        if (slugOpe === item.operation.slug && item.abandonedAt === null) {
            errorAccess = false
        }
    })
    return !errorAccess
}

export async function getOperationID(): Promise<number> {
    const opeSlug = getOperation()

    const allOp = await getSessionUserOperations()

    // Sur localhost (pas de slug d'opération), on prend la première opération active de l'utilisateur
    if (!opeSlug || opeSlug === 'localhost') {
        const active = allOp.find(el => el.abandonedAt === null)
        if (active) {
            return active.operation.id
        }
        return -1
    }

    const op = allOp.find(el => {
        return el.operation.slug === opeSlug
    })

    if (!op) {
        return -1
    }

    return op.operation.id
}
